module.exports = __webpack_public_path__ + "assets/img/00026.0ba9908b.png";